import React, { useState, useEffect, FunctionComponent, useCallback, useRef } from 'react';
import { Presentation } from './presentation';
import { RecruitmentShowProps as Props, RecruitmentShowState } from './types';
import { Analytics } from '../../../utils/gtm';
import { useModal } from '../../../hooks/useModal';
import { getCsrfToken } from '../../../libs/csrfToken';
import { postConnectRecruitment, recordForDropout } from '../../../services/personConnectRecruitments';
import { useLoginRegisterModals } from '../../../hooks/useLoginRegisterModals';
import { useDevice } from '../../../hooks/device';

export const Component: FunctionComponent<Props> = (props) => {
  const { recruitmentId, companyId, userId, isPreview, role, status, hideTopEntryButton = false } = props;
  const { isPc } = useDevice();
  useEffect(() => {
    if (!isPreview) {
      Analytics.handleRecruitmentView(recruitmentId, companyId, userId, role, status);
    }
  }, [isPreview, recruitmentId, companyId, userId, role, status]);

  const [state, setState] = useState<RecruitmentShowState>({
    icon: '',
    companyName: '',
    employmentTypes: [],
    regularEmployee: false,
    recruitmentTitle: '',
    image: '',
    flash: false,
    flashType: '',
    flashMessage: '',
    isLogin: false,
    dataCategory: {
      recruitmentContent: 'recruitmentcontent',
      stopRecruitmentContent: 'stoprecruitmentcontent',
      brandRecruitments: 'brand_recruitments'
    },
    dataCategoryRecruitmentRegisterModal: 'recruitmentcontent_register_popup',
    dataValueRecruitmentShowContent: {
      companyName: 'company_name',
      topNotLoginEntry: 'top_not_login_entry',
      topLoggedInEntry: 'top_logged_in_entry',
      topLoggedInScoutEntry: 'top_logged_in_scout_entry',
      topNotLoginAttentionEntry: 'top_not_login_attention_entry',
      topLoggedInAttentionEntry: 'top_logged_in_attention_entry',
      topLoggedInScoutAttentionEntry: 'top_logged_in_scout_attention_entry',
      topLoggedInToMessage: 'top_logged_in_to_message',
      notLoginEntry: 'not_login_entry',
      loggedInEntry: 'logged_in_entry',
      loggedInScoutEntry: 'logged_in_scout_entry',
      loggedInToMessage: 'logged_in_to_message',
      recruitmentAttention: 'recruitment_attention',
      companyPeopleLink: 'company_people_link',
      selfStoriesMore: 'self_stories_more',
      selfStories: 'self_stories',
      moreSelfRecruitments: 'more_self_recruitments',
      moreBrandRecruitments: 'more_brand_recruitments',
      relatedSelfRecruitments: 'related_self_recruitments',
      relatedBrandRecruitments: 'related_brand_recruitments',
      moreRelatedSelfRecruitments: 'more_related_self_recruitments',
      moreRelatedSoRecruitments: 'more_related_so_recruitments',
      relatedSoRecruitments: 'related_so_recruitments',
      scoutMessage: 'scout_message',
      moreScoutMessage: 'more_scout_message',
      index: 'index',
      whatToDo: 'what_to_do',
      desiredPerson: 'desired_person',
      recruitmentInfo: 'recruitment_info',
      companyPeople: 'company_people',
      whatDoing: 'what_doing',
      companyRole: 'company_role',
      companyInfo: 'company_info',
      companyStories: 'company_stories',
      companyMags: 'company_mags',
      brandRecruitments: 'brand_recruitments',
      companyRecruitments: 'company_recruitments',
      occupationRecruitments: 'occupation_recruitments'
    },
    dataValueRecruitmentShowBottom: {
      relatedRecruitments: 'related_recruitments',
      recruitmentHistories: 'recruitment_histories',
      recruitmentTags: 'recruitment_tags',
      recruitmentJoblocationOccupation: 'recruitment_joblocation_occupation',
      recruitmentJoblocationOccupationDetail: 'recruitment_joblocation_occupation_detail',
      recruitmentOtherJoblocationPrefecture: 'recruitment_other_joblocation_prefecture',
      recruitmentOtherJoblocationCity: 'recruitment_other_joblocation_city',
      recruitmentOtherOccupation: 'recruitment_other_occupation',
      recruitmentOtherOccupationDetail: 'recruitment_other_occupation_detail'
    },
    dataValueRecruitmentRegisterModal: {
      toLogin: 'to_login',
      line: 'line',
      facebook: 'facebook',
      apple: 'apple'
    }
  });
  const [connectMessageBoxId, setConnectMessageBoxId] = useState<number | null>(props.messageBoxId);

  // エントリーモーダル関連
  const { isOpen: isConnectModalOpen, close: handleConnectModalClose, open: handleConnectModalOpen } = useModal(false, { lockBody: false });
  const { isOpen: isConnectCompleteModalOpen, close: handleConnectCompleteModalClose, open: handleConnectCompleteModalOpen } = useModal(false, { lockBody: false });
  const [interest, setInterest] = useState<'want_to_work' | 'want_to_hear' | 'interesting'>(
    'want_to_work'
  );
  const [isConnected, setIsConnected] = useState<boolean>(props.connectedFlag);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  // ログインモーダル関連
  const {
    isLoginModalOpen,
    isRegisterModalOpen,
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
  } = useLoginRegisterModals(false);

  useEffect(() => {
    if (props.isLoginError && sessionStorage.getItem('login_modal_from_button') === 'recruitment') {
      handleToggleLoginModal();
    }
  }, []);

  useEffect(() => {
    const run = async () => {
      try {
        const routeType = sessionStorage.getItem("route_type");
        const fromId = sessionStorage.getItem("route_recruitment_id");

        const currentId = String(recruitmentId);
        const isTargetRoute = routeType === "recruitment" || routeType === "recruitment_new";

        if (props.isUser && isTargetRoute && fromId === currentId && !isConnected) {
          // ★ recruitment → 1(ログイン→エントリー)、recruitment_new → 2(新規登録→エントリー)
          const dropoutType = routeType === "recruitment" ? 1 : 2;
          const response = await recordForDropout(props.recruitmentId, getCsrfToken(), dropoutType);
          if (response.status === 'success') {
            handleConnectModalOpen();
          } else if (response.status === 'error') {
            handleFlash(true, 'danger', response.errormessage ?? 'エラーが発生しました');
          }
        }
      } catch (error) {
        console.log(error);
        alert(`エラーが発生しました：${error}`);
      } finally {
        sessionStorage.removeItem("route_type");
        sessionStorage.removeItem("route_recruitment_id");
      }
    };
    run();
  }, [recruitmentId]);

  const handleRegisterModalOpen = useCallback(() => {
    if (isPreview) {
      alert('プレビューのため実行できません');
      return;
    }

    handleToggleRegisterModal();
    if (isRegisterModalOpen) {
      document.body.removeAttribute('style');
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isPreview, state.isLogin, isRegisterModalOpen]);

  const handleSwitchLoginModalOpen = useCallback(() => {
    handleToggleRegisterModal();
    handleToggleLoginModal();
  }, []);

  const handleFlash = useCallback((flash: boolean, flashType: string, flashMessage: string) => {
    setState((prev) => ({
      ...prev,
      flash,
      flashType,
      flashMessage
    }));
  }, []);

  const handleClickEntry = useCallback(async () => {
    try {
      const response = await recordForDropout(props.recruitmentId, getCsrfToken());
      setState(prev => ({ ...prev, ...response }));
      handleConnectModalOpen();
    } catch (error) {
      console.log(error);
    }
  }, [props.recruitmentId, recordForDropout, getCsrfToken, handleConnectModalOpen]);

  const handleClickModalBg = () => {
    handleConnectModalClose();
    handleConnectCompleteModalClose();
  };

  const handleSubmitConnect = useCallback(async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (isSubmittingRef.current) return; // 多重送信防止
    isSubmittingRef.current = true;
    setIsSubmitting(true); // buttonのdisable

    try {
      const body = {
        how_interested: interest,              // ラジオの値
        recruitment_id: props.recruitmentId    // hidden input の値
      };
      const response = await postConnectRecruitment(body, getCsrfToken());
      if (response.errormessage) {
        alert(`エラーが発生しました：${response.errormessage}`);
        return;
      } else {
        setConnectMessageBoxId(response.messageBoxId ?? null);
        // dataLayer.push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'entry_recruitment',
          event_recruitment_id: recruitmentId,
          event_company_id: companyId,
          // SP上部エントリーボタンのA/Bテスト（PCは表示差分がないため送らない）
          ...(!isPc && {
            event_ab_test: hideTopEntryButton ? 'top_entry_button__hidden' : 'top_entry_button__shown',
          }),
        });
        // モーダル切替（React state）
        handleConnectModalClose();          // 第一モーダルを閉じる
        handleConnectCompleteModalOpen();   // 第二モーダルを開く
        // エントリーボタンの「メッセージを確認」に変更
        setIsConnected(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      isSubmittingRef.current = false; // 多重送信防止解除
      setIsSubmitting(false); // buttonのdisable解除
    }
  }, [
    interest,
    recruitmentId,
    companyId,
    isPc,
    hideTopEntryButton,
    handleConnectModalClose,
    handleConnectCompleteModalOpen,
  ]);

  const handleChangeInterest = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.currentTarget.value as 'want_to_work' | 'want_to_hear' | 'interesting';
      setInterest(value);
    },
    []
  );

  const handlePreviewClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isPreview) {
      e.preventDefault();
      alert('プレビューのため実行できません');
    }
  };

  const handleIsLogin = useCallback(() => {
    setState((prev) => ({ ...prev, isLogin: true }));
  }, []);

  return (
    <Presentation
      {...props}
      state={state}
      isConnectModalOpen={isConnectModalOpen}
      isConnectCompleteModalOpen={isConnectCompleteModalOpen}
      interest={interest}
      isConnected={isConnected}
      connectMessageBoxId={connectMessageBoxId}
      isLoginModalOpen={isLoginModalOpen}
      isRegisterModalOpen={isRegisterModalOpen}
      isSubmitting={isSubmitting}
      handleToggleLoginModal={handleToggleLoginModal}
      handleChangeModal={handleChangeModal}
      handleFlash={handleFlash}
      handleRegisterModalOpen={handleRegisterModalOpen}
      handleSwitchLoginModalOpen={handleSwitchLoginModalOpen}
      handleConnectModalOpen={handleConnectModalOpen}
      handleClickEntry={handleClickEntry}
      handleClickModalBg={handleClickModalBg}
      handleSubmitConnect={handleSubmitConnect}
      handleChangeInterest={handleChangeInterest}
      handlePreviewClick={handlePreviewClick}
      handleIsLogin={handleIsLogin}
    />
  );
};
